import React from 'react';
import { FaUserCircle, FaMapMarkerAlt } from 'react-icons/fa';

/**
 * Premium ProfessionalCard: matches attached screenshot and TopTalent premium style
 */
const ProfessionalCard = ({ professional, onCardClick }) => {
  // Determine expertise as string
  let expertise = '';
  if (Array.isArray(professional.expertise) && professional.expertise.length > 0) {
    expertise = professional.expertise[0];
  } else if (typeof professional.expertise === 'string') {
    expertise = professional.expertise;
  }

  return (
    <div
      className="bg-white rounded-2xl shadow-lg overflow-hidden flex flex-col items-center p-0 cursor-pointer hover:shadow-2xl transition-shadow duration-200"
      style={{ minWidth: 300 }}
      onClick={() => onCardClick && onCardClick(professional)}
      tabIndex={0}
      role="button"
      onKeyPress={e => { if (e.key === 'Enter') onCardClick && onCardClick(professional); }}
    >
      {/* Gradient Header */}
      <div className="w-full h-28 bg-gradient-to-r from-blue-500 to-purple-500 relative flex items-center justify-center">
        {/* Profile Image - overlaps header and card body */}
        <div className="absolute left-1/2 transform -translate-x-1/2 bottom-[-48px] z-10">
          <div className="w-24 h-24 rounded-full border-4 border-white shadow-lg overflow-hidden bg-white">
            {professional.photoURL ? (
              <img
                src={professional.photoURL}
                alt={professional.fullName}
                className="w-full h-full object-cover"
                onError={e => {
                  e.target.onerror = null;
                  e.target.style.display = 'none';
                  e.target.parentNode.innerHTML = (
                    '<div class=\"w-full h-full flex items-center justify-center bg-gray-100\">' +
                    '<svg class=\"text-gray-400 text-3xl\" fill=\"currentColor\" viewBox=\"0 0 24 24\"><path d=\"M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z\"/></svg>' +
                    '</div>'
                  );
                }}
              />
            ) : (
              <div className="w-full h-full flex items-center justify-center bg-gray-100">
                <FaUserCircle className="text-gray-400 text-3xl" />
              </div>
            )}
          </div>
        </div>
      </div>
      {/* Card Content */}
      <div className="flex flex-col items-center w-full pt-16 pb-8 px-6">
        {/* Name */}
        <h3 className="text-xl font-semibold text-gray-900 mb-1 mt-1">{professional.fullName}</h3>
        {/* City */}
        {professional.city && (
          <div className="flex items-center text-blue-600 font-medium text-base mb-2">
            <FaMapMarkerAlt className="mr-1.5" />
            <span>{professional.city}</span>
          </div>
        )}
        {/* Expertise as a single tag */}
        {expertise && (
          <span className="inline-block bg-blue-50 text-blue-700 font-normal px-4 py-1 rounded-full text-sm mb-4 border border-blue-100">
            {expertise}
          </span>
        )}
        {/* Bio Preview */}
        {professional.bio && (
          <div className="text-gray-600 text-center text-base font-normal mb-8 line-clamp-2" style={{ minHeight: 48 }}>
            {typeof professional.bio === 'string' ? professional.bio : JSON.stringify(professional.bio)}
          </div>
        )}

      </div>
    </div>
  );
};

export default ProfessionalCard;
